import React, { useEffect, useState } from "react";
import { ButtonBase } from "@reusejs/react";
import { esignDocument } from "services";
import Loader from "../../../layouts/Loader";
import { useRouter } from "next/router";
import AadharMismatchModal from "./AadharMismatchModal";
const VerifyBiddersApplication = ({ bidderData, id }: any) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [modal, setModal] = useState<any>(false);
  const [errorMessage, setErrorMessage] = useState<any>("");
  const router = useRouter();

  useEffect(() => {
    if (bidderData?.esigned_data?.signer_response?.status === "FAIL") {
      setModal(true);
      setErrorMessage(bidderData?.esigned_data?.signer_response?.errorMessage);
    }
  }, []);

  const handleSubmit = async () => {
    let payload = {
      bidder_uuid: id,
      pdf_url: bidderData?.esigned_data?.pdf_url,
      redirect_url: `${process.env.NEXT_PUBLIC_BD_URL}kyc/${id}?step=verification_result`,
      redirect_url_failure: `${process.env.NEXT_PUBLIC_BD_URL}kyc/${id}?step=verify_application`,
    };
    setIsDisabled(true);
    const res: any = await esignDocument(payload);
    if (
      res &&
      res?.redirect_response?.signerdetail &&
      res?.redirect_response?.signerdetail[0]?.esignUrl
    ) {
      router.push(res?.redirect_response?.signerdetail[0]?.esignUrl);
    }
  };
  const PDFViewer = ({ pdfUrl }: any) => (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe src={pdfUrl} width="100%" height="100%" frameBorder="0" />
    </div>
  );
  return (
    <div className="min-h-screen mx-auto">
      <div className="mx-auto max-w-5xl border py-6 px-12 rounded-md space-y-6">
        <div className="flex flex-col justify-center items-center">
          <h2 className="font-bold tracking-wide text-2xl">
            Verify Your Application
          </h2>
          <p className="tracking-tighter pt-1 text-gray-400">
            Read carefully before proceeding
          </p>
        </div>
        <div className="flex justify-center">
          <PDFViewer pdfUrl={bidderData?.esigned_data?.pdf_url} />
        </div>
        <div className="flex justify-end text-center pt-2">
          <ButtonBase
            variant="primary"
            type="button"
            label={"Save & Submit"}
            onClick={() => handleSubmit()}
            disabled={isDisabled}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-green-600 hover:bg-green-700",
              textColor: "text-white",
              border: "any",
              padding: "px-4 py-2",
            }}
            // disabled={!emdPaymentForm.getField("accept_terms_condition")}
            // busy={emdPaymentForm.busy}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      </div>
      {modal && (
        <AadharMismatchModal setModal={setModal} errorMessage={errorMessage} />
      )}
    </div>
  );
};

export default VerifyBiddersApplication;
